import React, { Component, Fragment } from "react";
import { Switch, Redirect } from "react-router-dom";

import Public from "../../routes/public";

import Gallery from "./gallery/";
import NotFound from "./notFound";

// import { getSetting } from "../../services/settingService";

class Landing extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = { setting: null };
  }

  // async componentDidMount() {
  //   this._isMounted = true;

  //   const { data: setting } = await getSetting();

  //   if (this._isMounted) this.setState({ setting });
  // }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <Fragment>
        <Switch>
          {/* <Redirect exact from="/" to="/login" /> */}
          <Public path="/gallery" component={Gallery} />
          <Public path="/404" component={NotFound} />

          <Redirect from="/" exact to="/dashboard" />

          <Redirect to="/404" />
        </Switch>
      </Fragment>
    );
  }
}

export default Landing;
